const width = 600;
const height = 400;

export default class Popup {
    constructor(element) {
        this.$element = $(element);
        this.url = this.$element.attr('href');
    }

    init() {
        this.parseOptions();

        this.$element
            .off('click.popup')
            .on('click.popup', e => {
                e.preventDefault();
                let properties = `width=${width},height=${height},scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
                window.open(this.$element.attr('href'), 'popup', properties);
            });
    }

    parseOptions() {
        this.width = parseInt(this.$element.data('popup-width'))|| this.width;
        this.height = parseInt(this.$element.data('popup-height'))|| this.height;
    }
}